<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getDepartmentAllList,
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        waringTypeOptions: [],
        orgIdOptions: [],
        form: [
          { // 手机号码
            label: '手机号码',
            value: 'mobilePhone',
            type: 'input',
            placeholder: '请输入手机号码',
          },
          { // 姓名
            label: '姓名',
            value: 'linkman',
            type: 'input',
            placeholder: '请输入姓名',
          },
          { // 收款名称
            label: '收款名称',
            value: 'receiverName',
            type: 'input',
            placeholder: '请输入收款名称',
          },
          { // 备注
            label: '备注',
            value: 'remark',
            type: 'input',
            placeholder: '请输入备注',
          },
          { // 银行卡
            label: '银行卡',
            value: 'bindCard',
            type: 'select',
            placeholder: '请选择',
            default: -1,
            options: [
              {
                label: '全部',
                value: -1,
              },
              {
                label: '已绑卡',
                value: 1,
              },
              {
                label: '未绑卡',
                value: 2,
              },
            ],
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 预警时间
      if (searchBoxData.insurance && searchBoxData.insurance.length > 0) {
        searchBoxData.insuranceStartDate = this.formatDate(searchBoxData.insurance[0]);
        searchBoxData.insuranceEndDate = this.formatDate(searchBoxData.insurance[1]);
        delete searchBoxData.insurance;
      }
      // 处理时间
      if (searchBoxData.DealDate && searchBoxData.DealDate.length > 0) {
        searchBoxData.startDealDate = this.formatDate(searchBoxData.DealDate[0]);
        searchBoxData.endDealDate = this.formatDate(searchBoxData.DealDate[1]);
        delete searchBoxData.DealDate;
      }
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'WARING_TYPE',
    });
    this.searchBoxData.waringTypeOptions = enumsList[0];
    this.searchBoxData.orgIdOptions = await getDepartmentAllList();
  },
};
</script>

<style lang="scss" scoped>
</style>
